import { FC } from "react";

import { ContentNavigationButtons } from "components/materials/ContentNavigationButtons";
import { type TopicType } from "components/server-types";
import { getNavigationValues } from "utils/urls";

type TopicNavigationButtonsProps = {
  className?: string;
  onChange?: (itemId: string) => void;
  disabled?: boolean;
  currentTopicId?: string;
  topics?: TopicType[];
};

/*
 * This component is used to navigate between topics.  It works in conjunction with ContentNavigationButtons.
 */
export const TopicNavigationButtons: FC<TopicNavigationButtonsProps> = ({
  className,
  onChange,
  currentTopicId,
  disabled = false,
  topics = [],
}) => {
  const topicIds = topics.map((topic) => topic.id);
  const { nextId, prevId } = getNavigationValues(topicIds, { currentId: currentTopicId });

  return (
    <ContentNavigationButtons
      className={className}
      disabled={disabled}
      kind="white"
      nextId={nextId}
      prevId={prevId}
      reference="topic"
      onChange={onChange}
    />
  );
};
